<template>
  <div class="journey-date-range">
    <JourneyDateSelect
      v-model="singleDateTime"
      :label="labelPrefix.to"
      :tooltip-text="labelPrefix.tooltipTextTo"
      :placeholder-date="labelPrefix.dateTo"
      :placeholder-time="labelPrefix.timeTo"
      @input="
        $emit('single', $event);
        handleSelection('origin', ...arguments);
      "
      :start-range="singleDateTime"
      :end-range="endRangeDateTime"
      :position="0"
      @toggle="toggleCalender('origin', ...arguments)"
    />
    <spacer v-if="isReturnJourney" :spacing="20" />
    <JourneyDateSelect
      v-if="isReturnJourney"
      v-model="returnDateTime"
      @input="
        $emit('return', $event);
        handleSelection('return', ...arguments);
      "
      :label="labelPrefix.from"
      :tooltip-text="labelPrefix.tooltipTextFrom"
      :placeholder-date="labelPrefix.dateFrom"
      :placeholder-time="labelPrefix.timeFrom"
      :start-range="singleDateTime"
      :end-range="endRangeDateTime"
      :position="1"
      :open="pickerActiveType === 'return' && pickerActive"
      @toggle="toggleCalender('return', ...arguments)"
    />
    <div class="journey-date-range__validation">
      <ValidationMessage
        v-if="
          isReturnJourney &&
            singleDateTime &&
            returnDateTime &&
            !$v.returnDateTime.greaterThanSingle
        "
      >
        Return date must be after outgoing
      </ValidationMessage>
    </div>
    <div
      ref="journeyDateContainer"
      class="tgmag-picker__container"
      :class="[{ 'tgmag-picker__container--active': pickerActive }]"
    >
      <div class="tgmag-picker__container-actions">
        <div class="d-flex justify-content-center align-items-center">
          <p>Select your travelling dates</p>
          <button @click="closeCalendar">
            <span class="icon-cross"></span>
          </button>
        </div>
      </div>
      <div v-if="isReturnJourney" class="tgmag-picker__container-dates">
        <div class="d-flex justify-content-center align-items-center">
          <div
            class="tgmag-picker__container-label"
            :class="{ active: pickerActiveType === 'origin' }"
          >
            <p>Departure date</p>
            <p v-if="singleDateTime">
              {{ singleDateTime | formatDateForUser }}
            </p>
            <p v-else>
              Select date
            </p>
          </div>
          <div
            class="tgmag-picker__container-label"
            :class="{ active: pickerActiveType === 'return' }"
          >
            <p>Return date</p>
            <p v-if="returnDateTime">
              {{ returnDateTime | formatDateForUser }}
            </p>
            <p v-else>
              Select date
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Spacer from "../Utilities/Spacer.vue";
import JourneyDateSelect from "../JourneyDateSelect";
import Vue from "vue";
import Vuelidate from "vuelidate";
import ValidationMessage from "../ValidationMessage";
import { JOURNEY_MODE_RETURN } from "./types.js";

Vue.use(Vuelidate);
export default {
  components: {
    JourneyDateSelect,
    Spacer,
    ValidationMessage
  },
  props: {
    mode: {
      type: String,
      default: JOURNEY_MODE_RETURN
    },
    labelPrefix: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  filters: {
    formatDateForUser: function(value) {
      if (!value) return "";
      value = moment(value).format("D MMM YYYY");
      return value;
    }
  },
  data() {
    return {
      pickerActive: false,
      pickerActiveType: null,
      singleDateTime: null,
      returnDateTime: null
    };
  },
  computed: {
    isReturnJourney() {
      return this.mode === JOURNEY_MODE_RETURN;
    },
    endRangeDateTime() {
      return this.isReturnJourney ? this.returnDateTime : null;
    }
  },
  methods: {
    toggleCalender(position, payload) {
      this.pickerActiveType = position;
      this.pickerActive = payload;
    },
    handleSelection(position) {
      if (!this.returnDateTime && !this.singleDateTime) return;
      this.pickerActiveType = position;
      if (
        this.returnDateTime &&
        this.singleDateTime &&
        moment(this.singleDateTime).isAfter(this.returnDateTime) &&
        position === "origin"
      ) {
        /*
         ** If the Origin date is after Return date, reset return date.
         */
        this.returnDateTime = null;
      }
    },
    closeCalendar() {
      this.pickerActive = false;
    }
  },
  validations() {
    function greaterThanSingle() {
      return moment(this.returnDateTime).isAfter(this.singleDateTime);
    }

    if (this.isReturnJourney) {
      return {
        returnDateTime: {
          greaterThanSingle
        }
      };
    }

    return {};
  }
};
</script>
<style lang="scss" scoped>
$parent-horizontal-padding: 30px;
$parent-horizontal-mobile-padding: 15px;
.journey-date-range {
  padding: 15px 0;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -$parent-horizontal-padding;
    height: 100%;
    width: calc((#{$parent-horizontal-padding} * 2) + 100%);
    background-color: #f9fafc;
    @include media-breakpoint-down(md) {
      left: -$parent-horizontal-mobile-padding;
      width: calc((#{$parent-horizontal-mobile-padding} * 2) + 100%);
    }
  }
  .journey-date-select__input label {
    background-color: #f9fafc;
  }
}
.journey-date-range__validation {
  position: relative;
  flex: 0 100%;
  width: 100%;
}
</style>
<style lang="scss">
.tgmag-picker {
  position: relative;
  display: flex;
  flex-direction: column;
  &--buttonattached {
    input {
      // When a button is grouped inside a .form-group and after an input
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      + .form-group {
        &__button {
          // When a button is grouped inside a .form-group and after an input
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
        }
      }
    }
  }
  &__container {
    display: none;
    pointer-events: none;
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: scroll;
    background-color: white;
    @include media-breakpoint-up(md) {
      width: auto;
      height: auto;
      overflow: visible;
      position: absolute;
      left: 50%;
      top: 100%;
      transform: translate3d(-50%, 0, 0);
      margin-bottom: 20px;
      min-width: 610px;
      background-color: transparent;
      box-shadow: 0 2px 10px 0 rgba(42, 56, 72, 0.2);
    }
    .pika-single {
      position: relative !important;
      box-shadow: none !important;
    }
    &--active {
      display: block;
      pointer-events: all;
      z-index: 99;
    }
  }
  &__container-actions {
    background: $graident-1;
    padding: $base-padding * 2 $base-padding;
    text-align: center;

    @include media-breakpoint-up(md) {
      display: none;
    }
    * {
      color: white;
    }
    p {
      color: white;
      font-weight: theme-weight("demi");
      font-size: 14px;
      margin: 0;
    }
    button {
      font-size: 24px;
      display: flex;
      align-items: center;
      appearance: none;
      background-color: transparent;
      border: 0;
    }
  }
  &__container-dates {
    @include media-breakpoint-up(md) {
      display: none;
    }
    .tgmag-picker__container-label {
      flex: 0 50%;
      text-align: center;
      padding: $base-padding;

      &:not(.active) {
        background-color: $input-button-inactive;
      }
      p {
        margin: 0;
        &:last-child {
          font-weight: theme-weight("demi");
        }
      }
      &.active {
        p {
          &:last-child {
            color: $success;
          }
        }
      }
    }
  }
}
</style>
